const appTypeItems = [
    {
      name: 'Connected Search',
      tag: 'connected-search',
    }
]

const appTypePretty = {
  'connected-search': 'Connected Search'
}

module.exports = {
    appTypeItems,
    appTypePretty
}